import config from '@/config';
import {
  ClassProgressResponse,
  StudentProgressResponse,
  PostQuizProgressResponse,
  QuizzesProgressResponse,
  ImprovableRecentActivitiesResponse,
  AchievementOfTheWeekResponse,
  OverviewProgressResponse,
} from '@/types/response'; //LevelTestResultsResponse
import { ProgressService } from '@/types/services';
import { UserState } from '@/types/user';
import axiosInstance from '@/utils/api-new';
import UserUtils from '@/utils/user';

export const progressService: ProgressService = {
  fetchQuizProgress: async (user: UserState | null) => {
    const resp: QuizzesProgressResponse | null = await axiosInstance.get(
      `${config.apiVersion}/user-progress/${user?.metadata.id}`
    );
    return resp;
  },
  fetchQuestionsProgress: async (user: UserState | null, quizId: number) => {
    const resp: QuizzesProgressResponse | null = await axiosInstance.get(
      `${config.apiVersion}/user-progress/${user?.metadata.id}/${quizId}`
    );

    return resp;
  },
  sendQuizProgressData: async (user: UserState | null, progress: any) => {
    const resp: PostQuizProgressResponse | null = await axiosInstance.post(
      `${config.apiVersion}/user-progress/${user?.metadata.id}`,
      progress
    );
    return resp;
  },
  fetchClassProgress: async (user: UserState | null, groupId: string) => {
    const fromToLanguage = UserUtils.fromToLanguage(user);

    const resp: ClassProgressResponse | null = await axiosInstance.get(
      `${config.apiVersion}/Teacher-view/students/${fromToLanguage}/${user?.metadata.id}/${groupId}`
    );

    return resp;
  },

  fetchOverviewClassProgress: async (user: UserState | null, groupId: string) => {
    const fromToLanguage = UserUtils.fromToLanguage(user);
    const resp: OverviewProgressResponse | null = await axiosInstance.get(
      `${config.apiVersion}/Teacher-view/my-class-overview/${fromToLanguage}/${user?.metadata.id}/${groupId}`
    );
    return resp;
  },
  fetchStudentProgress: async (user: UserState | null, studentId: string, level: number) => {
    const resp: StudentProgressResponse | null = await axiosInstance.get(
      `${config.apiVersion}/teacher-view/student/overview/${user?.metadata.id}/${studentId}?level=${level}`
    );

    return resp;
  },
  fetchAchievementOfTheWeek: async (user: UserState | null) => {
    const resp: AchievementOfTheWeekResponse | null = await axiosInstance.get(
      `${config.apiVersion}/user-progress/achievements/${user?.id}?fromToLang=${UserUtils.fromToLanguage(
        user
      )}`
    );

    return resp;
  },
  sendCanDoAnswer: async (user: UserState | null, data: any) => {
    const resp: PostQuizProgressResponse | null = await axiosInstance.post(
      `${config.apiVersion}/user-progress/can-do-answer/${user?.metadata.id}`,
      data
    );
    return resp;
  },
  fetchImprovableRecentActivities: async (user: UserState | null) => {
    const resp: ImprovableRecentActivitiesResponse | null = await axiosInstance.get(
      `${config.apiVersion}/user-progress/activities/improve/${user?.id}?fromToLang=${UserUtils.fromToLanguage(
        user
      )}`
    );
    return resp;
  },
};
